'use strict'

const ES6Promise = require('es6-promise').Promise

export default class API {
  getTreatmentOptions () {
    let treatmentOptionsPromise = new ES6Promise(function (resolve, reject) {
      resolve([{
        id: '123125345',
        name: 'Implants / Crowns'
      }, {
        id: '43543525',
        name: 'Replace Missing Teeth'
      }, {
        id: '26264356',
        name: 'Fillings'
      }, {
        id: '5684568',
        name: 'Whitening'
      }, {
        id: '45685648345',
        name: 'Cosmetic'
      }, {
        id: '2342342',
        name: 'Others'
      }])
    })
    return treatmentOptionsPromise
  }

  getPackages () {
    let packagesPromise = new ES6Promise(function (resolve, reject) {
      resolve([{
        id: 'aushd',
        name: 'Smile',
        voucherValue: 1000,
        voucherPrice: 891,
        voucherSaving: 109,
        weeklyPayment: 99,
        paymentWeeks: 9,
        fortnightlyPayment: 178.20,
        fortnightlyPaymentWeek: 5
      }, {
        id: 'au2qeshd',
        name: 'Sparkle',
        voucherValue: 3000,
        voucherPrice: 2673,
        voucherSaving: 327,
        weeklyPayment: 99,
        paymentWeeks: 27,
        fortnightlyPayment: 190.93,
        fortnightlyPaymentWeek: 14
      }, {
        id: 'aussdhd',
        name: 'Royal',
        voucherValue: 5000,
        voucherPrice: 4455,
        voucherSaving: 545,
        weeklyPayment: 99,
        paymentWeeks: 45,
        fortnightlyPayment: 193.70,
        fortnightlyPaymentWeek: 23
      }])
    })
    return packagesPromise
  }
}



// WEBPACK FOOTER //
// ./src/components/services/api.js